class wuwDiscount {
  constructor(parent) {
    this.parent = parent;
    if(!this.parent) return;
    this.copyDisountCode();
  }

  copyDisountCode() {
    let parent = this.parent;
    let copyCodeBtn = parent.querySelector('.copycode-btn-js');
    let disountCodeVaule = parent.querySelector('.wuw-discount-couponcode');
    let copyTextlabel = parent.querySelector('.copy-text');

    copyCodeBtn.addEventListener('click', (e) => {
      disountCodeVaule.select();
      disountCodeVaule.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(disountCodeVaule.value);

      copyTextlabel.innerHTML = 'COPIED';
      copyCodeBtn.classList.add('copied-text');

      setTimeout(() => {
        copyTextlabel.innerHTML = 'COPY';
        copyCodeBtn.classList.remove('copied-text');
      }, 2000);

    })
  }
}
new wuwDiscount(document.querySelector('.wuw-discount-banner'));